import { RootState } from 'app/store';
import { createSelector } from 'reselect';
import { ApiSubmission } from 'app/types/reviews';

export const getSubmissionsAsync = createSelector(
  (state: RootState, action: string) => {
    if (action) {
      return state.reviews.submissionsAsync[action];
    }
    return state.reviews.submissionsAsync;
  },
  (state) => state
);

export const getAssignedSubmissions = (state: RootState): ApiSubmission[] => {
  return state.reviews.submissions.assigned;
};

export const getCompletedSubmissions = (state: RootState): ApiSubmission[] => {
  return state.reviews.submissions.completed;
};
